module.exports = __webpack_public_path__ + "static/media/sidny-see-491852-unsplash.51dc3dcd.jpg";